
export const getHeaderTitle = (index, type) => {
  const cumulative = type === 'cumulative';
  let output = cumulative ? '%' : '';
  output += 'ALA ';
  output += cumulative && index !== 1 ? '1-' : '';
  output += index === 0 ? 'Fail' : index;

  return output;
};

export const getSeparateValues = (values = []) => values.map(item => ({
  ...item,
  alaLevelsCount: item.originalCount,
}));

export const getCumulativeValues = (values = []) => values.map((item) => {
  const allCount = item.originalCount.reduce((a, b) => a + b, 0);
  const getPercentage = (value, index, arr) => {
    const count = arr.slice(1, index + 1).reduce((a, b) => a + b, 0);
    return index ? Math.round((count / allCount) * 100) : 100;
  };

  return {
    ...item,
    alaLevelsCount: item.originalCount.map(getPercentage),
  };
});
